import { AiOutlineDashboard, AiOutlineShoppingCart } from 'react-icons/ai'
import { BiCategory, BiSolidCoupon } from 'react-icons/bi'
import { FaImages, FaPrint, FaUsers } from 'react-icons/fa'
import { AiOutlinePartition } from 'react-icons/ai'
// import { FaCodePullRequest } from 'react-icons/fa6'
// import { IoIosChatbubbles } from 'react-icons/io'
import { IoMdAdd } from 'react-icons/io'
import { MdViewList } from 'react-icons/md'
import { TbBasketDiscount } from 'react-icons/tb'
// import { BsCartCheck } from 'react-icons/bs'
// import { CiShop } from 'react-icons/ci'
// import { BsFillChatQuoteFill } from 'react-icons/bs'
// import { CgProfile } from 'react-icons/cg'
// import { IoIosNotificationsOutline } from 'react-icons/io'
import { BiCog } from 'react-icons/bi'

export const allNav = [
  {
    id: 1,
    title: 'Dashboard',
    icon: <AiOutlineDashboard />,
    role: 'admin',
    path: '/admin/dashboard',
  },
  {
    id: 2,
    title: 'Category',
    icon: <BiCategory />,
    role: 'admin',
    path: '/admin/dashboard/category',
  },
  // {
  //   id: 3,
  //   title: 'Sub Category',
  //   icon: <AiOutlinePartition />,
  //   role: 'admin',
  //   path: '/admin/dashboard/subcategory',
  // },
  {
    id: 4,
    title: 'Settings',
    icon: <BiCog />,
    role: 'admin',
    // path: '/admin/dashboard/product-properties',
    subNav: [
      {
        id: 101,
        title: 'Colors',
        path: '/admin/dashboard/colors',
      },
      {
        id: 102,
        title: 'Properties',
        path: '/admin/dashboard/product-properties',
      },
    ],
  },

  {
    id: 5,
    title: 'Add Product',
    icon: <IoMdAdd />,
    role: 'admin',
    path: '/admin/dashboard/add-product',
  },
  {
    id: 6,
    title: 'All Products',
    icon: <MdViewList />,
    role: 'admin',
    path: '/admin/dashboard/products',
  },
  {
    id: 7,
    title: 'Discount Products',
    icon: <TbBasketDiscount />,
    role: 'admin',
    path: '/admin/dashboard/discount-product',
  },
 
  {
    id: 8,
    title: 'Orders',
    icon: <AiOutlineShoppingCart />,
    role: 'admin',
    path: '/admin/orders',
  },

  {
    id: 9,
    title: 'Banners',
    icon: <FaImages />,
    role: 'admin',
    path: '/admin/dashboard/banners',
  },
  {
    id: 10,
    title: 'Customers',
    icon: <FaUsers />,
    role: 'admin',
    path: '/admin/dashboard/customers',
  },
  // {
  //   id: 11,
  //   title: 'Print House',
  //   icon: <FaPrint />,
  //   role: 'admin',
  //   path: '/admin/dashboard/printhouse',
  // },
  // {
  //   id: 9,
  //   title: 'Reklams',
  //   icon: <BiCategory />,
  //   role: 'admin',
  //   path: '/admin/dashboard/reklam',
  // },
  // // {
  // //   id: 6,
  // //   title: 'Payment Request',
  // //   icon: <MdPayment />,
  // //   role: 'admin',
  // //   path: '/admin/dashboard/payment-request',
  // // },
  // {
  //   id: 10,
  //   title: 'Active Shop',
  //   icon: <FaCodePullRequest />,
  //   role: 'admin',
  //   path: '/admin/dashboard/sellers-request',
  // },
  // {
  //   id: 11,
  //   title: 'Deactive Shops',
  //   icon: <FaUserTimes />,
  //   role: 'admin',
  //   path: '/admin/dashboard/deactive-sellers',
  // },

  {
    id: 12,
    title: 'Users',
    icon: <FaUsers />,
    role: 'admin',
    path: '/admin/dashboard/users',
  },
  {
    id: 13,
    title: 'Orders',
    icon: <AiOutlineShoppingCart />,
    role: 'poster',
    path: '/poster/orders',
  },
  {
    id: 14,
    title: 'Orders',
    icon: <AiOutlineShoppingCart />,
    role: 'orderAdmin',
    path: '/orderAdmin/orders',
  },
  {
    id: 15,
    title: 'Orders',
    icon: <AiOutlineShoppingCart />,
    role: 'stockAdmin',
    path: '/stockAdmin/orders',
  },

  {
    id: 16,
    title: 'Add Product',
    icon: <IoMdAdd />,
    role: 'stockAdmin',
    path: '/stock/addProducts',
  },
  {
    id: 17,
    title: 'All Products',
    icon: <MdViewList />,
    role: 'stockAdmin',
    path: '/stockAdmin/products',
  },

  

  // {
  //   id: 13,
  //   title: 'Customers',
  //   icon: <FaUsers />,
  //   role: 'admin',
  //   path: '/admin/dashboard/customers',
  // },

  // {
  //   id: 14,
  //   title: 'Live Chat',
  //   icon: <IoIosChatbubbles />,
  //   role: 'admin',
  //   path: '/admin/dashboard/chat-sellers',
  // },
  // {
  //   id: 15,
  //   title: 'Dashboard',
  //   icon: <AiOutlineDashboard />,
  //   role: 'seller',
  //   path: '/seller/dashboard',
  // },

  // {
  //   id: 17,
  //   title: 'Discount Products',
  //   icon: <TbBasketDiscount />,
  //   role: 'seller',
  //   path: '/seller/dashboard/discount-product',
  // },
  // {
  //   id: 18,
  //   title: 'Orders',
  //   icon: <BsCartCheck />,
  //   role: 'seller',
  //   path: '/seller/dashboard/orders',
  // },
  // // {
  // //   id: 16,
  // //   title: 'Payments',
  // //   icon: <MdPayment />,
  // //   role: 'seller',
  // //   path: '/seller/dashboard/payments',
  // // },
  // // {
  // //   id: 17,
  // //   title: 'Chat-Customer',
  // //   icon: <IoChatbubbles />,
  // //   role: 'seller',
  // //   path: '/seller/dashboard/chat-customer',
  // // },
  // {
  //   id: 19,
  //   title: 'Chat-Support',
  //   icon: <BsFillChatQuoteFill />,
  //   role: 'seller',
  //   path: '/seller/dashboard/chat-support',
  // },
  // {
  //   id: 20,
  //   title: 'Coupons',
  //   icon: <BiSolidCoupon />,
  //   role: 'admin',
  //   path: '/admin/dashboard/coupon',
  // },
  // {
  //   id: 21,
  //   title: 'Profile',
  //   icon: <CgProfile />,
  //   role: 'seller',
  //   path: '/seller/dashboard/profile',
  // },
  // {
  //   id: 22,
  //   title: 'Notifications',
  //   icon: <IoIosNotificationsOutline />,
  //   role: 'admin',
  //   path: 'admin/dashboard/notifications',
  // },
  // {
  //   id: 23,
  //   title: 'Dashboard',
  //   icon: <IoIosNotificationsOutline />,
  //   role: 'user',
  //   path: 'user/dashboard',
  // },
]
